/**
 *
 * @param {string} text Main text for graph / Title
 * @param {string} country Country code
 * @param {string} year Year
 * @param {string} period Month of Quarter
 * @returns String with file name ending in .png
 */
export function getGraphFileName(text, country, year, period) {
  let filename = text + "_" + country + "_" + year;
  if (period) filename += "_" + period;
  return filename + ".png";
}
